import * as React from 'react';

export interface ISvgIconGeneralProps {
  iconWidth?: string | number;
  iconHeight?: string | number;
  iconFill?: string;
}

export interface ISvgIconProps extends ISvgIconGeneralProps {
  iconName: string;
}

const SvgIcon: React.FunctionComponent<ISvgIconProps> = ({ iconName, iconFill, iconWidth, iconHeight }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={iconWidth} height={iconHeight}>
    <use xlinkHref={`#${iconName}`} fill={iconFill} />
  </svg>
);

SvgIcon.defaultProps = {
  iconWidth: 24,
  iconHeight: 24,
};

export default React.memo(SvgIcon);



// WEBPACK FOOTER //
// ./src/components/SvgIcon/index.tsx